var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 2.66675V5.33341H11",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 13.3334V10.6667H5.00016",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24683 6.00008C3.48055 5.18693 3.93248 4.45343 4.55827 3.87144C5.18405 3.28945 5.96267 2.87917 6.81749 2.68127C7.67231 2.48337 8.57371 2.50479 9.43619 2.74349C10.2987 2.98219 11.0922 3.43008 11.7402 4.04341L13.6668 5.33341M2.3335 10.6667L4.26016 11.9567C4.9081 12.5701 5.70166 13.018 6.56414 13.2567C7.42662 13.4954 8.32802 13.5168 9.18284 13.3189C10.0377 13.121 10.8163 12.7107 11.4421 12.1287C12.0678 11.5467 12.5198 10.8132 12.7535 10.0001",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c7a8d49159d793e8a2746b43a86cd3c3.svg";
export { ForwardRef as ReactComponent };